import { Component } from "@angular/core";

@Component({
  selector: "app-channelworks-logo",
  templateUrl: "./channelworks-logo.component.html",
  styleUrls: ["./channelworks-logo.component.scss"],
})
export class ChannelWorksLogoComponent {}
